import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FeaturesClient } from '@unity/clients';
import { SessionService } from '@unity/services/session.service';
import { UnityFeatureTypeStrings } from '@unity/utils/types';
import { map, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  private readonly featuresClient = inject(FeaturesClient);
  private readonly sessionService = inject(SessionService);

  private sharedReplay$ = this.featuresClient.getAll().pipe(
    map(x => x.map(x => x.feature_flag)),
    shareReplay({ refCount: true, bufferSize: 1 })
  );

  private readonly $_features = toSignal(this.sharedReplay$);

  public readonly $features = computed(() => {
    const loggedIn = this.sessionService.$isLoggedIn();
    const features = this.$_features();
    if (!loggedIn || !features) {
      return [];
    }
    return features;
  });

  public isEnabled(feature?: UnityFeatureTypeStrings) {
    if (!feature) {
      return true;
    }

    const features = this.$features();
    return features.some(x => x === feature);
  }
}
